export default __webpack_public_path__ + "static/media/intro-analysis.7ef6ced7.png";